import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const LumpsumTable = ({ showTable }) => {
  const lumpsumState = useSelector((state) => state.lum);
  const {textData} = useLocale();
  

  const [reportData, setReportData] = useState([]);
  const {
    age = "",
    monthlyInvestment = "", // Actually stores the total lumpsum investment amount
    approxReturn = "",
    noOfInvestementYear = "",
    swpStartYear = "",
    yearlyWithdraw = "",
    yearlyIncrementInWithdrawSwp = "",
    investmentAmounts = [],
    investmentDataSIP = [] ,
    filterInvestmentData = []
  } = lumpsumState || {};


  const fullState = useSelector(state => state);


  useEffect(() => {

    
    if (showTable) {
      // Even if we don't have all the data, try to generate something
      generateReportData();
    }
  }, [showTable, age, monthlyInvestment, approxReturn, noOfInvestementYear, swpStartYear, yearlyWithdraw, yearlyIncrementInWithdrawSwp, fullState, lumpsumState]);

  const generateReportData = () => {
    // Create a processed version of the data if needed
    // If investmentDataLUM from the Redux store is already in the format you need,
    // you can just set that directly
    if (investmentDataSIP && investmentDataSIP.length > 0) {
      setReportData(investmentDataSIP);
    } else {
      // Fallback calculation if data isn't available
      const data = generateLumpsumData();
      setReportData(data);
    }
  };

  const generateLumpsumData = () => {
    const currentAge = Number(age);
    const initialInvestment = Number(typeof monthlyInvestment === 'string' 
      ? monthlyInvestment.replace(/,/g, '') 
      : monthlyInvestment);
    const yearlyReturn = Number(approxReturn) / 100;
    const investmentYears = Number(noOfInvestementYear);
    const swpStart = Number(swpStartYear);
    const initialYearlyWithdraw = Number(typeof yearlyWithdraw === 'string' 
      ? yearlyWithdraw.replace(/,/g, '') 
      : yearlyWithdraw);
    const withdrawalIncrement = Number(yearlyIncrementInWithdrawSwp) / 100;

    let data = [];
    let ageCount = currentAge;
    let totalBalance = initialInvestment;
    let totalInvestment = initialInvestment;
    let investmentAmounts = [];

    for (let year = 1; year <= 45; year++) {
       const additionalInvestment = parseFloat(investmentAmounts?.[year - 1]) || 0;
      
      if (year <= investmentYears) {
        totalInvestment += additionalInvestment;
        totalBalance += additionalInvestment;
      }

       const yearlyGrowth = totalBalance * yearlyReturn;
      totalBalance += yearlyGrowth;

      let swpAmount = 0;
      let monthlyReturn = 0;

       if (year >= swpStart) {
         swpAmount = initialYearlyWithdraw * Math.pow(1 + withdrawalIncrement, year - swpStart);
        monthlyReturn = swpAmount / 12;
        
         totalBalance -= swpAmount;
      }

       let ltcgAmount = 0;
      if (year >= swpStart && swpAmount > 0) {
        ltcgAmount = swpAmount * (swpStart === 1 ? 0.15 : 0.10);
      }

      data.push({
        tabName: "Lumpsum & SWP Calculation",
        year: year,
        age: ageCount++,
        swpStartYear: year >= swpStart ? swpStart : year,
        monthlyInvestment: year === 1 ? Math.round(initialInvestment) : "",
        yearlyInvestment: year === 1 ? Math.round(initialInvestment) : "",
        totalInvestment: year === 1 ? Math.round(totalInvestment) : "",
        investmentAmounts: additionalInvestment > 0 ? Math.round(additionalInvestment) : "",
        yearlyReturn: Math.round(totalBalance + swpAmount),
        swpAmount: swpAmount > 0 ? Math.round(swpAmount) : "",
        monthlyReturn: monthlyReturn > 0 ? Math.round(monthlyReturn) : "",
        yearlyReturnAfterSWP: Math.round(totalBalance),
        ltcgAmount: ltcgAmount > 0 ? Math.round(ltcgAmount) : ""
      });
    }

    return data;
  };


  const columns = [
    { key: 'age', label: textData.tableLabels.age, format: (value) => value },
    { key: 'year', label: textData.tableLabels.year, format: (value) => value },
    { 
      key: 'initialInvestment', 
      label: `${textData.tableLabels.initialInvestment} (${textData.currency})`, 
      format: (value) => !value  ? "-" : `${FormatIndianNumber(Math.round(value))}` 
    },
    { 
      key: 'additionalInvestment', 
      label: `${textData.tableLabels.additionalInvestment} (${textData.currency})`, 
      format: (value) => !value  ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'totalInvestment', 
      label: `${textData.tableLabels.totalInvestment} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'yearlyReturn', 
      label: `${textData.tableLabels.yearlyReturn} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'swpAmount', 
      label: `${textData.tableLabels.swpAmount} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
 

    { 
      key: 'yearlyReturnAfterSWP', 
      label: `${textData.tableLabels.yearlyReturnAfterSWP} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },

    { 
      key: 'monthlyReturn', 
      label: `${textData.tableLabels.monthlyReturn} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
     { 
          key: 'ltcgAmount', 
          label:`${textData.tableLabels.ltcgAmount} (${textData.currency})`, 
          format: (value) => !value ? "-" : `${FormatIndianNumber(Math.ceil(value))}`
        }
  ];

  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.lumpsumCalc} ${textData.report}`}
      data={filterInvestmentData}
      columns={columns}
      analyticsEventName="download_lumpsum_swp_report"
      reportTitle={textData.reportTitle.lumpsumReport}
      fileName="lumpsum_swp_detail"
    />
  );
};

export default LumpsumTable;